import './assets/css/scss_import';
import React from 'react';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import RouteIndex from './page/index';

const App = () => {
  return (
    <div>
      <RouteIndex />
    </div>
  );
};

export default App;
